import LegalLayout, { H2, P, UL, B } from "./LegalLayout";

export default function Termeni() {
    return (
        <LegalLayout title="Termeni și condiții" updated="iunie 2026">
            <H2>1. Cine suntem</H2>
            <P>
                Site-ul <B>www.optimsafe.ro</B> (denumit în continuare „Site-ul") este operat sub marca{" "}
                <B>OPTIM SAFE</B> de către <B>Ilaș Gabriela Elena</B>, asistent în brokeraj care desfășoară
                activitate de distribuție de asigurări în numele și în contul{" "}
                <B>SAFETY BROKER DE ASIGURARE S.A.</B> — broker de asigurare autorizat de Autoritatea de
                Supraveghere Financiară (ASF), înmatriculat în Registrul Brokerilor sub nr. RBK-293/15.06.2005,
                cu sediul în Calea Giulești nr. 8D, et. 2, sector 6, București, parte a grupului global Acrisure.
            </P>
            <P>
                Ne puteți contacta la telefon <B>0745 643 348</B> sau prin e-mail la <B>oferte@optimsafe.ro</B>.
            </P>

            <H2>2. Obiectul site-ului</H2>
            <P>
                Site-ul are rol de prezentare a serviciilor de intermediere în asigurări și de facilitare a
                contactului dintre vizitatori și OPTIM SAFE, în vederea obținerii de oferte pentru produse de
                asigurare (RCA, CASCO, locuință, sănătate, viață, călătorii etc.), precum și pentru alte produse
                financiare (credite, leasing, pensii private, economisire) intermediate prin partenerii noștri.
            </P>
            <P>
                Site-ul <B>nu vinde direct polițe de asigurare</B> și nu încheie contracte online. Trimiterea unei
                cereri de ofertă prin formular nu creează nicio obligație de cumpărare pentru vizitator.
            </P>

            <H2>3. Caracterul orientativ al estimărilor</H2>
            <P>
                Calculatorul RCA disponibil pe Site oferă <B>estimări orientative</B>, bazate pe tarife medii de
                referință publicate de ASF. Aceste estimări nu reprezintă oferte ferme. Prețul final al unei polițe
                este stabilit exclusiv de societățile de asigurare, în funcție de istoricul de daune, clasa
                bonus-malus, perioada de asigurare și alți factori de risc.
            </P>

            <H2>4. Utilizarea site-ului</H2>
            <UL
                items={[
                    "Vă obligați să furnizați date reale, corecte și complete în formularele de contact.",
                    "Este interzisă utilizarea Site-ului în scopuri ilegale, frauduloase sau care pot afecta funcționarea acestuia.",
                    "Este interzisă copierea, reproducerea sau distribuirea conținutului Site-ului fără acordul scris al OPTIM SAFE.",
                ]}
            />

            <H2>5. Proprietate intelectuală</H2>
            <P>
                Conținutul Site-ului (texte, grafică, logo, imagini, structură) este proprietatea OPTIM SAFE sau a
                partenerilor săi și este protejat de legislația privind drepturile de autor. Mărcile și logo-urile
                societăților de asigurare menționate pe Site aparțin deținătorilor lor de drept și sunt folosite
                exclusiv cu titlu informativ, pentru a indica companiile ale căror produse pot fi comparate.
            </P>

            <H2>6. Limitarea răspunderii</H2>
            <P>
                Depunem toate eforturile pentru ca informațiile publicate să fie corecte și actualizate, însă nu
                garantăm caracterul complet sau lipsit de erori al acestora. OPTIM SAFE nu răspunde pentru
                eventuale prejudicii rezultate din utilizarea informațiilor cu caracter orientativ de pe Site.
                Condițiile finale ale produselor de asigurare sunt cele din documentele contractuale emise de
                asigurători.
            </P>

            <H2>7. Protecția datelor personale</H2>
            <P>
                Prelucrarea datelor cu caracter personal este descrisă în{" "}
                <a href="/politica-de-confidentialitate" className="text-[#0d3d2e] underline font-medium">
                    Politica de confidențialitate
                </a>{" "}
                și în{" "}
                <a href="/politica-cookies" className="text-[#0d3d2e] underline font-medium">
                    Politica Cookie
                </a>
                .
            </P>

            <H2>8. Soluționarea litigiilor</H2>
            <P>
                Prezentii termeni sunt guvernați de legea română. Orice dispută se soluționează pe cale amiabilă,
                iar în caz contrar de instanțele competente din România. Consumatorii pot apela și la:
            </P>
            <UL
                items={[
                    <>
                        <B>ANPC</B> — Autoritatea Națională pentru Protecția Consumatorilor:{" "}
                        <a href="https://anpc.ro" target="_blank" rel="noopener noreferrer" className="underline">anpc.ro</a>
                    </>,
                    <>
                        <B>SAL-Fin</B> — Entitatea de Soluționare Alternativă a Litigiilor în domeniul financiar nebancar:{" "}
                        <a href="https://salfin.ro" target="_blank" rel="noopener noreferrer" className="underline">salfin.ro</a>
                    </>,
                    <>
                        <B>Platforma SOL</B> — soluționarea online a litigiilor la nivel european:{" "}
                        <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer" className="underline">ec.europa.eu/consumers/odr</a>
                    </>,
                ]}
            />

            <H2>9. Modificarea termenilor</H2>
            <P>
                OPTIM SAFE își rezervă dreptul de a modifica acești termeni. Versiunea actualizată se publică pe
                această pagină și produce efecte de la data publicării.
            </P>
        </LegalLayout>
    );
}
